import classnames from 'classnames';
const { __ } = wp.i18n;
import renderSVG from "../../../util/RTCLGB-icon-controls/renderIcon"
function StyleGrid(props) {
	const {
		style,
		desc_limit,
		show_desc,
		show_count,
		show_logo,
		show_title,
		count_after_text,
		col_xl,
		col_lg,
		col_md,
		col_sm,
		col_mobile,

		data,
	} = props;

	const wrapperClass = classnames([
		'rtcl',
		'rtcl-gb-listing-store',
		'style-' + style
	])



	return [
		data.length ? (

			<div className={wrapperClass}>

				{data.map((store, index) => (

					<div key={index} className="rtcl-item">

						{(show_logo && store.logo) && (
							<div className="rtcl-logo-wrap">
								<div className="rtcl-logo">
									<a href={store.permalink} dangerouslySetInnerHTML={{ __html: store.logo }}></a>
								</div>
							</div>
						)}

						<div className="rtcl-content">

							{(show_title && store.title) && (
								<h3 className="rtcl-title">
									<a href={store.permalink}>{store.title}</a>
								</h3>
							)}

							{(show_count && store.count) && (
								<div className="rtcl-count">{!count_after_text ? store.count == 1 ? store.count + __(' Ad') : store.count + __(' Ads') : store.count + ' ' + count_after_text}</div>
							)}

							{(show_desc && store.description) && (
								<p className="rtcl-description">{`${store.description.split(' ', desc_limit).join(' ') + '....'}`}</p>
							)}
						</div>

					</div>

				))}

			</div>


		) : ''
	]
}

export default StyleGrid;